// CATEGORY NOTES
export const actionTypes = {
    LOAD_USER_ITEM_SEARCH_EXCLUSIONS: 'LOAD_USER_ITEM_SEARCH_EXCLUSIONS',
    UPDATE_ITEM_SEARCH_EXCLUSIONS: 'UPDATE_ITEM_SEARCH_EXCLUSIONS',
    ADD_ITEM_SEARCH_EXCLUSION: 'ADD_ITEM_SEARCH_EXCLUSION',
    DELETE_ITEM_SEARCH_EXCLUSION: 'DELETE_ITEM_SEARCH_EXCLUSION'
};